import React, { Component } from "react"
import EditIncidentTypes from "../../../Types/EditIncidentTypes"
import axios from "axios"
import AxiosConfig from "../../../../../utilities/AxiosConfig"
import snackBar from "../../../../../utilities/snackBar/SnackBar"
import WorkCompReferenceTypes from "../../../Types/WorkCompReferenceTypes"
import incidentParams from "./IncidentParams"
import moment from "moment"
import ReferenceTypes from "../../../Types/ReferenceTypes"
import IncidentControlsBar from "./IncidentControlsBar/IncidentControlsBar"
import IncidentTimelineTypes from "../../../Types/IncidentTimelineTypes"
import { Accordion, Button, Card, Modal } from "react-bootstrap"
import DeleteIncident from "./DeleteIncident/DeleteIncident"
import BasicIncident from "./EditIncident/BasicIncident/BasicIncident"
import IncidentDetails from "./EditIncident/IncidentDetails/IncidentDetails"
import IncidentTimeline from "./IncidentTimeline/IncidentTimeline"
import reggie from "src/utilities/Reggie"
import "./Incident.css"
import { boolean } from "yup"

interface Props {
    WorkersCompensationIncidentId: number
    workCompReference: WorkCompReferenceTypes
    reference: ReferenceTypes
    contextUserId: string | number
    hasEdits: Function
    refreshIncidents: Function
    setOpenIncident: Function
    toggleViewAll: Function
    readOnly: boolean
}

interface State {
    incident: EditIncidentTypes | {}
    copy: EditIncidentTypes | {}
    timelineItems: Array<IncidentTimelineTypes>
    eventType: string
    loading: boolean
    loadingTimeline: boolean
    addSupervisor: boolean
    deleteSupervisors: boolean
    addAppointment: boolean
    editAppointment: boolean
    expandDescription: boolean
    expandRestrictions: boolean
    isDirty: boolean
    large: string
    delete: boolean
}

class Incident extends Component<Props, State> {

    timeFormat = "YYYY-MM-DD"
    maxDaysOff = 548
    highlights = ["IncidentTypeId", "IncidentDateUTC", "IncidentStateId", "ClaimNumber", "IncidentStatusId", "FullDutyReleaseDateUTC", "DaysOffWork", "DaysLightDuty", "IncidentDescription", "Restrictions", "RestrictionsDescription", "MedicalTreatment", "OshaRecordable"]

    state = {
        loading: false,
        loadingTimeline: false,
        incident: incidentParams,
        copy: incidentParams,
        timelineItems: [],
        eventType: "",
        addSupervisor: false,
        deleteSupervisors: false,
        addAppointment: false,
        editAppointment: false,
        expandDescription: false,
        expandRestrictions: false,
        isDirty: false,
        large: "",
        delete: false
    }

    setEventType = (s: string) => {
        this.setState({ eventType: s })
    }

    componentDidMount() {
        for (const [key] of Object.entries(incidentParams)) {
            incidentParams[key] = null
        }
        this.setState({ incident: JSON.parse(JSON.stringify(incidentParams)), copy: JSON.parse(JSON.stringify(incidentParams)) })
        this.getIncident()
    }

    handleChange = (event: { target: { value: string | null } }) => {
        let input = event.target.value
        let incident = this.state.incident
        let eventType = this.state.eventType
        let eventTypes = Object.keys(incident)
        let temp: any = incident
        //@ts-ignore
        if (((eventType === "DaysLightDuty") || (eventType === "DaysOffWork")) && parseInt(input) >= this.maxDaysOff) {
            input = "548"
            snackBar({ text: `Maximum days off are ${this.maxDaysOff}`, type: "error", timeout: 4000 })
        }
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.appendParams([param])
            }
        }
    }

    handleDelete = () => {
        this.setState({ delete: !this.state.delete })
    }

    appendParams = (params: Array<object>) => {
        if (!this.props.readOnly) {
            for (let i = 0; i < params.length; i++) {
                let key = Object.keys(params[i])
                let value = Object.values(params[i])
                if (value[0] !== "") {
                    incidentParams[key[0]] = value[0]
                } else {
                    incidentParams[key[0]] = null
                }
            }
            this.setState({ incident: incidentParams })
            const self = this
            setTimeout(() => {
                self.submitCheck()
            }, 200)
        }
    }

    submitCheck = (clean?: boolean) => {

        if (clean) {
            this.props.hasEdits(false)
            this.setState({ isDirty: false })
        } else {
            let a = JSON.parse(JSON.stringify(this.state.incident))
            let b = this.state.copy

            // if (a.IncidentDescription) {
            //     a.IncidentDescription = reggie.filterTags(a.IncidentDescription)
            // }
            // if (a.RestrictionsDescription) {
            //     a.RestrictionsDescription = reggie.filterTags(a.RestrictionsDescription)
            // }
            // if (b.IncidentDescription) {
            //     b.IncidentDescription = reggie.filterTags(b.IncidentDescription)
            // }
            // if (b.RestrictionsDescription) {
            //     b.RestrictionsDescription = reggie.filterTags(b.RestrictionsDescription)
            // }
            // //console.log("a:", a)
            // //console.log("b:", b)

            let result: any = {};
            for (let i in b) {
                if (!a.hasOwnProperty(i) || b[i] !== a[i]) {
                    result[i] = b[i];
                }
            }

            let temp = Object.keys(result)

            if (temp.length > 3) {
                this.props.hasEdits(true)
                this.setState({ isDirty: true })
            } else {
                this.props.hasEdits(false)
                this.setState({ isDirty: false })
            }
        }
    }

    getIncident = (clean?: boolean) => {
        this.setState({ loading: true })
        axios.get(process.env.REACT_APP_API_URL + "/api/workComp/getWorkCompIncident/" + this.props.WorkersCompensationIncidentId, AxiosConfig.configValue())
            .then(res => {
                let temp = res.data
                if (res.data.MedicalAppointments.length > 0) {
                    temp.MedicalAppointments.sort((a: any, b: any) => moment(b.CreatedDateUtc).unix() - moment(a.CreatedDateUtc).unix()).reverse()
                }
                this.setState({ loading: false, expandDescription: false, expandRestrictions: false, incident: JSON.parse(JSON.stringify(temp)), copy: JSON.parse(JSON.stringify(temp)), isDirty: false })
                for (const [key] of Object.entries(res.data)) {
                    incidentParams[key] = res.data[key]
                }
            }).then(() => {
                this.getTimeline()
            }).then(() => {
                this.submitCheck(clean)
            })
            .catch(err => {
                snackBar({ text: "Failed to fetch Incident", type: "error", timeout: 4000 })
                //console.log(err)
                this.setState({ loading: false })
            })
    }

    saveIncident = (rb: any) => {
        this.setState({ loading: true, })
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/UpdateWorkCompIncidentPost", rb, AxiosConfig.configValue("min"))
            .then(() => {
                this.getIncident(true)
                this.props.hasEdits(false)
                this.props.refreshIncidents()
                if ((rb.IncidentStatusId > 1)) {
                    this.props.setOpenIncident(-1)
                    this.props.toggleViewAll(rb.WorkersCompensationIncidentId)
                }
                snackBar({ text: "Incident Updated", type: "success", timeout: 4000 })
            })
            .catch(err => {
                //console.log(err)
                this.setState({ loading: false, expandDescription: false, expandRestrictions: false })
                snackBar({ text: "Failed to update incident", type: "error", timeout: 4000 })
            })
    }

    getTimeline = () => {
        this.setState({ loadingTimeline: true })
        axios.get(process.env.REACT_APP_API_URL + `/api/workComp/getWorkCompTimelineList/${this.props.WorkersCompensationIncidentId}/true `, AxiosConfig.configValue())
            .then(res => {
                this.setState({ timelineItems: res.data, loadingTimeline: false })
            })
            .catch(err => {
                this.setState({ loadingTimeline: false })
                snackBar({ text: "Failed to fetch Timeline", type: "error", timeout: 4000 })
                //console.log(err)
            })
    }

    updateTimeline = (rb: IncidentTimelineTypes) => {
        this.setState({ loading: true, })
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentTimelinePost", rb, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ loading: false })
                snackBar({ type: "success", text: "Timeline updated", timeout: 3000 })
                this.getTimeline()

            }).catch(err => {
                //console.log(err)
                this.setState({ loading: false })
                snackBar({ type: "error", text: "Error updating timeline", timeout: 3000 })
            })
    }

    downloadIncident = () => {
        snackBar({ text: "This button will eventually download the incident", type: "success", timeout: 4000 })
    }

    formatRb = (keys: Array<string>) => {
        let rb: any = {}
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i]
            let value = incidentParams[key]
            rb[key] = value
        }
        return rb
    }

    toggleLarge = (large: string) => {
        this.setState({ large: large })
    }

    render() {

        const incident = this.state.incident
        const features = JSON.parse(process.env.REACT_APP_HR_TEMP_TOGGLES || "")

        // //console.log("Incident Params: ", incidentParams)
        // //console.log("Incident State: ", incident)
        // //console.log("Incident Copy: ", this.state.copy)
        // //console.log("Dirty?: " + this.state.isDirty)
        // //console.log("Last Updated: " + this.state.lastUpdated)
        // //console.log("editDex: " + this.editDex)
        // //console.log("editList: " , this.state.editList)
        // //console.log(this.props)

        return (
            <div className="Incident" id={`workers-comp-incident-fs-${false}`}>

                <IncidentControlsBar
                    isDirty={this.state.isDirty}
                    downloadIncident={this.downloadIncident}
                    saveIncident={this.saveIncident}
                    formatRb={this.formatRb}
                    loading={this.state.loading}
                    deleteIncident={this.handleDelete}
                    readOnly={this.props.readOnly}
                />

                <BasicIncident
                    incident={incident}
                    incidentReference={this.props.workCompReference}
                    appendParams={this.appendParams}
                    setEventType={this.setEventType}
                    handleChange={this.handleChange}
                    timeFormat={this.timeFormat}
                    readOnly={this.props.readOnly}
                />

                <Accordion defaultActiveKey={"0"}>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            <div className="IncidentDetailsAccordionHeader">
                                <p>Incident Details</p>
                            </div>
                            {/* <div className="IncidentLargeViewBtn" onClick={() => this.toggleLarge("incident-details")}>
                                <span className="material-icons">open_in_full</span>
                            </div> */}
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <IncidentDetails
                                incident={incident}
                                userId={this.props.contextUserId}
                                setEventType={this.setEventType}
                                eventType={this.state.eventType}
                                appendParams={this.appendParams}
                                timeFormat={this.timeFormat}
                                reference={this.props.reference}
                                workCompReference={this.props.workCompReference}
                                saveIncident={this.saveIncident}
                                isDirty={this.state.isDirty}
                                loading={this.state.loading}
                                getIncident={this.getIncident}
                                readOnly={this.props.readOnly}
                            />
                        </Accordion.Collapse>
                    </Card >
                </Accordion >

                {this.state.large === "incident-details" && <div className="IncidentLargeViewModal">
                    <Modal
                        show={true}
                        backdrop="static"
                        keyboard={true}
                        centered={true}
                        size="xl"
                    >
                        <Modal.Header>
                            <div className="IncidentLargeViewModalHeader">
                                <p>Incident Details</p>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="IncidentlargeViewModalBody">
                                <IncidentDetails
                                    incident={incident}
                                    userId={this.props.contextUserId}
                                    setEventType={this.setEventType}
                                    eventType={this.state.eventType}
                                    appendParams={this.appendParams}
                                    timeFormat={this.timeFormat}
                                    reference={this.props.reference}
                                    workCompReference={this.props.workCompReference}
                                    saveIncident={this.saveIncident}
                                    isDirty={this.state.isDirty}
                                    loading={this.state.loading}
                                    getIncident={this.getIncident}
                                    readOnly={this.props.readOnly}
                                />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="IncidentLargeViewModalFooter">
                                <Button id="incident-large-view-exit-btn" variant="secondary" onClick={() => this.toggleLarge("")}>Back</Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>}

                {features.Timeline && this.state.large !== "timeline" && <Accordion defaultActiveKey={"0"}>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="1">
                            <div className="TimelineAccordionHeader">
                                <p>Timeline</p>
                            </div>
                            <div className="IncidentLargeViewBtn" onClick={() => this.toggleLarge("timeline")}>
                                <span className="material-icons">open_in_full</span>
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <div>
                                <IncidentTimeline
                                    WorkersCompensationIncidentId={this.props.WorkersCompensationIncidentId}
                                    reference={this.props.reference}
                                    timelineItems={this.state.timelineItems}
                                    loadingTimeline={this.state.loadingTimeline}
                                    timeFormat={this.timeFormat}
                                    toggleLarge={this.toggleLarge}
                                    isModal={false}
                                    contextUser={this.props.contextUserId}
                                    refreshTimeline={this.getTimeline}
                                    updateTimeLineItems={this.updateTimeline}
                                    incidentUserId={incident.EmployeeId}
                                    readOnly={this.props.readOnly}
                                />
                            </div>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>}
                {features.Timeline && this.state.large === "timeline" && <div className="IncidentLargeViewModal">
                    <Modal id="timeline-large-view-modal"
                        show={true}
                        backdrop="static"
                        keyboard={true}
                        centered={true}
                        size="xl"
                    >
                        <Modal.Header>
                            <div className="IncidentLargeViewModalHeader">
                                <p>Timeline</p>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="IncidentlargeViewModalBody">
                                <IncidentTimeline
                                    WorkersCompensationIncidentId={this.props.WorkersCompensationIncidentId}
                                    reference={this.props.reference}
                                    timelineItems={this.state.timelineItems}
                                    loadingTimeline={this.state.loadingTimeline}
                                    timeFormat={this.timeFormat}
                                    toggleLarge={this.toggleLarge}
                                    isModal={true}
                                    contextUser={this.props.contextUserId}
                                    refreshTimeline={this.getTimeline}
                                    updateTimeLineItems={this.updateTimeline}
                                    incidentUserId={incident.EmployeeId}
                                    readOnly={this.props.readOnly}
                                />
                            </div>
                            <span id="incident-timeline-modal-body-backdrop" className="material-icons">timeline</span>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="IncidentLargeViewModalFooter">
                                <Button id="incident-large-view-exit-btn" variant="secondary" onClick={() => this.toggleLarge("")}>Back</Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>}
                {this.state.delete && <DeleteIncident
                    incident={incident}
                    toggleDelete={this.handleDelete}
                    userId={this.props.contextUserId + ""}
                    refreshIncidents={this.props.refreshIncidents}
                    setOpenIncident={this.props.setOpenIncident}
                />}
            </div >
        )
    }
}

export default Incident